export default "__VITE_ASSET__e$gNgyxp__"